import React from 'react';
import {
    CustomerSidebar,
    SaleSidebar,
    TeamSidebar,
    DashboardSidebar,
    ManagementAccountAction,
    ManagementAccountProfile
} from '../Sidebars';
import './Sidebar.scss';
import { BillSidebar } from './BillSidebar';
import { PartnerSidebar } from './PartnerSidebar';


export const ManagementSidebar: React.FC = () => {
    return (
        <div className='management-sidebar-wrapper'>
            <div>
                <ManagementAccountProfile />
                <DashboardSidebar />
                <CustomerSidebar />
                <SaleSidebar />
                <BillSidebar />
                <PartnerSidebar />
                <TeamSidebar />
            </div>
            <ManagementAccountAction />
        </div>
    );
};
